module.exports = __webpack_public_path__ + "static/media/coin-graphic-sale.e78d974a.png";